'use client';

import Link from 'next/link';

import { buttonVariants } from '@/components/ui/Button';
import { cn } from '@/lib/utils';

type RouteFallbackProps = {
  title: string;
  description: string;
  actionHref?: string;
  actionLabel?: string;
  retryLabel?: string;
  onRetry?: () => void;
  className?: string;
};

export const RouteFallback = ({
  title,
  description,
  actionHref = '/',
  actionLabel = 'Return to SportsFi',
  retryLabel = 'Try again',
  onRetry,
  className,
}: RouteFallbackProps) => (
  <main className={cn('flex min-h-screen items-center justify-center bg-white px-6 py-16', className)}>
    <section className="w-full max-w-lg rounded-lg border border-gray200 bg-white p-8 text-center shadow-sm">
      <p className="text-sm font-semibold uppercase tracking-wide text-primary">SportsFi</p>
      <h1 className="mt-3 text-2xl font-semibold text-gray900">{title}</h1>
      <p className="mt-3 text-sm leading-6 text-gray600">{description}</p>
      <div className="mt-6 flex flex-wrap justify-center gap-3">
        {onRetry ? (
          <button type="button" className={buttonVariants({ variant: 'secondary' })} onClick={onRetry}>
            {retryLabel}
          </button>
        ) : null}
        {actionHref ? (
          <Link href={actionHref} className={buttonVariants({ variant: 'primary' })}>
            {actionLabel}
          </Link>
        ) : null}
      </div>
    </section>
  </main>
);
